<!--多张门票核销-->
<template>
  <div>
    <van-nav-bar
      fixed
      placeholder
      title="选择门票"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <!--门票列表-->
    <ul class="productList">
      <li
        class="card mv-2x relative"
        v-for="item in ticketList"
        :key="item.id"
        @click="checkOne(item)"
      >
        <div class="flex-between">
          <h3 class="text-1">{{ item.productName }}</h3>
          <p
            class="flex-shrink"
            :class="{ primary: item.status === 5, red: item.status === 6 }"
          >
            {{ item.statusText }}
          </p>
        </div>

        <p class="mt-1x">票号：{{ item.auxiliaryId }}</p>
        <!--剧场票时展示-->
        <div v-if="item.placeName">
          <p class="mt-1x">
            场地座位：{{ `${item.placeName} ${item.seatName}` }}
          </p>
          <p class="mt-1x">场次：{{ item.spaceTime }}</p>
        </div>
        <p class="mt-1x">游玩日期：{{ item.useDate | date("yyyy-mm-dd") }}</p>
        <p class="mt-1x">
          有效期：{{ item.beginValidTime | date }} ~
          {{ item.endValidTime | date }}
        </p>
        <p class="mt-1x">已核销次数：{{ item.useNum }}</p>
        <p class="mt-1x">
          可核销次数：<b>{{
            item.canUseNum > -1 ? item.canUseNum : "不限次数"
          }}</b>
          <van-button
            type="primary"
            plain
            hairline
            @click="oneCheck(item)"
            style="height: 30px"
            class="ml-2x"
            >核销</van-button
          >
        </p>
        <van-checkbox
          :value="item.checked"
          icon-size="0.48rem"
          class="check"
        ></van-checkbox>
      </li>
    </ul>
    <!--底部按钮-->
    <!--<footer-bar >-->
    <div class="footer flex-between pl-2x">
      <div class="flex-start">
        <van-checkbox v-model="checked" @click="checkAll">全选</van-checkbox>
        <p class="ml-1x">共 {{ count }} 张</p>
      </div>
      <van-button type="primary" style="width: 3rem" @click="batchCheck"
        >确定核销</van-button
      >
    </div>
    <!--</footer-bar>-->

    <!--核销成功-->
    <van-dialog v-model="show">
      <div class="text-c box">
        <van-icon name="checked" size="1rem" class="primary" />
        <p class="font-xl mt-2x">核销成功</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { orderTicketverify } from "../../../api/search";
import { apiOrderTicketCheckArray } from "../../../api/order";
import { speak } from "../../../utils/hardware";
export default {
  name: "TicketOff",
  data() {
    return {
      checked: false,
      ticketList: [],
      show: false,
    };
  },
  created() {
    this.loadTicket();
  },
  computed: {
    count() {
      return this.ticketList.reduce((curr, next) => {
        curr += next.checked ? 1 : 0;
        return curr;
      }, 0);
    },
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.back();
    },
    // 加载门票列表
    loadTicket() {
      orderTicketverify({
        keyword: this.$route.query.code,
      })
        .then((res) => {
          res.forEach((item) => {
            item.checked = false;
          });
          this.ticketList = res;
        })
        .catch(() => {});
    },
    // 单选
    checkOne(item) {
      item.checked = !item.checked;
      this.checked = this.ticketList.every((temp) => temp.checked);
    },
    // 全选
    checkAll() {
      this.ticketList.forEach((item) => {
        item.checked = this.checked;
      });
    },
    //单张核销
    oneCheck(item) {
      this.toCheck([item.auxiliaryId], item.productName);
    },
    // 批量核销
    batchCheck() {
      this.toCheck(
        this.ticketList
          .filter((item) => item.checked)
          .map((temp) => temp.auxiliaryId),
        0
      );
    },
    //核销
    toCheck(codeList, type) {
      apiOrderTicketCheckArray({
        codeList: codeList,
      })
        .then(() => {
          this.show = true;
          this.loadTicket();
          // speak("核销成功");
          if (type) {
            speak(type + "核销成功");
          } else {
            speak("批量核销成功");
          }
          // speak(res.message ? res.message : "核销成功");
        })
        .catch((res) => {
          speak(res.message ? res.message : "核销失败");
        })
        .finally(() => {
          this.loadTicket();
        });
    },
  },
};
</script>

<style lang="less" scoped>
.check {
  position: absolute;
  bottom: 0.32rem;
  right: 0.32rem;
}
.productList {
  margin-bottom: 140/100rem;
}
.footer {
  width: 100%;
  position: fixed;
  bottom: 0;
  background: white;
  z-index: 100;
}
</style>
